export const CODE_COMPLETE_DEBOUNCE_TIME = 600;

export interface CodeCompletionRequest {
  query: string;
  suffix: string | null;
  metadata: {
    reportToken: string;
    organizationToken: string;
    organizationHandle: string;
    planCode: string;
  };
}

export interface CodeCompletionResponse {
  renderedCode: string[];
  requestId: string;
}
export interface Position {
  row: number;
  column: number;
}
export interface Token {
  value: string;
  type: string;
  index: number;
  start: number;
}

export interface EditorContext {
  codeLine: string;
  codeLineAsArray: string[];
  cursorPosition: Position;
  tokenAtCursor: Token | null;
  tokenBeforeCursor: Token | null;
  tokenAfterCursor: Token | null;
  linePrefix: string;
  lineSuffix: string;
  textFromStartToCurrent: string;
  textFromCurrentToEnd: string;
}

export interface CodeCompletionContext {
  currentCodeLine: string;
  currentCodeLineAsArray: string[];
  currentCursorPosition: Position;
  currentCellToken: string;
  currentNotebookCode: string;
  currentNotebookCells: [string, string][];
  previousCells: [string, string][];
  nextCells: [string, string][];
  currentCodePrefix: string;
  currentCodeSuffix: string;
  currentCellPrefix: string;
  currentCellSuffix: string;
  tokenAtCursor: Token | null;
  tokenBeforeCursor: Token | null;
  tokenAfterCursor: Token | null;
  currentLinePrefix: string;
  currentLineSuffix: string;
}

export interface CodeCompletionSuggestion {
  suggestion: string;
  cellPrefix: string;
  cellSuffix: string;
  suggestionId: string;
  suggestionCursorPosition: Position;
}

export interface CodeCompletionFeedback {
  accepted: boolean;
  requestId: string;
  message?: string;
  rating?: number;
  metadata: {
    reportToken: string;
    organizationToken: string;
    organizationHandle: string;
    planCode: string;
  };
}
